module.exports = __webpack_public_path__ + "img/lunch_title--available.03882470.png";